
























































































































































































































































































































































































import { Component, Watch, Vue } from 'vue-property-decorator'
/* component */
import Loading from '@/app/components/Common/Loading.vue'
import SpFieldImg from '@/app/components/SpField/SpFieldImg.vue'
import SpHeader from '@/app/components/Common/SpHeader.vue'
/* module */
import Local from '@/app/module/local'
import Session from '@/app/module/session'
import DateClass from '@/app/module/date'
import CommonClass from '@/app/module/common'
import { routerPath, errorFlag } from '@/app/model/store/domain/const'
/* api */
import GetImageApi from '@/app/model/api/getImageApi'
import RecordDetailApi from '@/app/model/api/recordDetailApi'

@Component({
  components: {
    Loading,
    SpFieldImg,
    SpHeader
  }
})
export default class SpFieldDetails extends Vue {
  /* 表示切り替え */
  private showNotFound: boolean = false
  private showLoading: boolean = true
  private showStemNum: boolean = false
  private showStemNumM2: boolean = false
  /* データ */
  private errorMessage: string = ''
  private alertText: string = ''
  private recordDate: number = 0
  private recordData: any = {
    planting: {
      record_date: '',
      record_user_name: '',
      record_user_id: null,
      remarks: '',
      point_icon: null
    },
    images: [],
    internal_factors: {
      stem_number: null,
      plant_height: null,
      leaf_age: null,
      spad: null
    },
    external_factors: {
      weather_name: '',
      temperature: null,
      temperature_highest: null,
      temperature_lowest: null,
      temperature_difference: null,
      water_level: null,
      water_temperature: null,
      soil_temperature: null,
      solar_radiation: null,
      humidity: null,
      windy_time: null,
      wind_velocity: null,
      rainfall: null,
      soil_ph: null,
      soil_ec: null,
      ph: null
    },
    harvest_risk: []
  }
  private viewHeight:number = 100

  created () {
    this.recordDate = parseInt(this.$route.params.record_date)
    this.getPlantingRecords()
  }

  mounted () {
    this.viewHeight = window.innerHeight
  }

  private countRisk () {
    if (this.recordData.harvest_risks === undefined || this.recordData.harvest_risks.length === 0) {
      return 0
    } else {
      return this.recordData.harvest_risks.length
    }
  }

  /* あい作 任意アイコンの判定 */
  private judgmentPointIcon (pointIcon: number) {
    switch (pointIcon) {
      // カメラ
      case 1:
        return require('@/assets/icon/aisaku_camera_icon.svg')

      // ★
      case 2:
        return require('@/assets/icon/black_star_icon.svg')

      // ☆
      case 3:
        return require('@/assets/icon/star_icon.svg')

      // !
      case 4:
        return require('@/assets/icon/exclamation_mark_icon.svg')

      // 不明
      default:
        return null
    }
  }

  private getPlantingRecords () {
    (async () => {
      const result = await RecordDetailApi.getRecordDetail(this.$route.params.plant_id, this.recordDate)
      if (result.isOk()) {
        this.recordData = result.getPayload()
        // 茎数表示切替
        if (this.recordData.planting.stem_number_type === 1 || this.recordData.planting.stem_number_type === 3) {
          this.showStemNum = true
        }
        if (this.recordData.planting.stem_number_type === 2 || this.recordData.planting.stem_number_type === 3) {
          this.showStemNumM2 = true
        }
      } else if (result.getPayload().status_code === '404') {
        // NotFoundエラー(生育記録追加ページへ遷移)
        this.$router.push('/sp/field/' + this.$route.params.field_id + '/' + this.$route.params.plant_id + '/record/create').catch(e => {})
      } else if (result.getPayload().status_code === '400' && result.getPayload().message === 'リクエストパラメータの値が不正です。') {
        // 日付形式エラーの場合はトップ画面へ遷移
        if (result.getPayload().message === 'リクエストパラメータの値が不正です。') {
          this.$router.push('/sp/field').catch(e => {})
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'sp', 'GET', 'alert')
      }
      const flag = this.$store.state.alertState.errorAlertFlag
      if (flag) {
        this.alertText = this.$store.state.alertState.errorMessage
        this.$store.commit('alertState/setErrorAlertFlag', false)
      }
      this.showLoading = false
    })()
  }

  private toPlantingDetail () {
    this.$store.commit('spFieldState/setBeforeRecordDate', this.recordDate)
    this.$router.push('/sp/field/' + this.$route.params.field_id + '/' + this.$route.params.plant_id)
  }

  private doEdit () {
    this.$router.push('/sp/field/' + this.$route.params.field_id + '/' + this.$route.params.plant_id + '/record/' + this.recordDate + '/edit')
  }

  private dateToStringYmd (date: any) {
    if (date !== '') {
      const updateDate = new Date(date.replace(/-/g, '/'))
      const formingDate = DateClass.toDoubleDigits(updateDate.getFullYear()) + '年' + DateClass.toDoubleDigits(updateDate.getMonth() + 1) + '月' + DateClass.toDoubleDigits(updateDate.getDate()) + '日'
      return formingDate
    }
  }
}
